import axios from 'axios';
import { logout } from '@/auth/services/logout-service';
import { AppError } from '@/domain/ErrorApp';
import { origin } from '@/global';

export const httpClient = axios.create({
  baseURL: origin,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  paramsSerializer: {
    indexes: null,
  },
});

const PUBLIC_AUTH_PATHS = ['/Cuenta/login', '/Seguridad/me', '/Cuenta/logoff', '/Cuenta/generate-code'];

httpClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const url: string = error.config?.url ?? '';
    const isPublicAuth = PUBLIC_AUTH_PATHS.some((path) => url.includes(path));

    if (status === 401 && !isPublicAuth) {
      await logout();
    }

    const data = error.response?.data;
    const payload = data && typeof data === 'object' ? data : { message: 'Error desconocido' };
    throw new AppError({ ...payload, status });
  }
);
